import { getDefaultRoadSettings, } from "../../settings/earthbrain-site-settings";
import { Road } from "../../site/road/earthbrain-road";
import { ConstructionState } from "../../site/trench/earthbrain-trench";
import { Activity, ActivityLogger } from "../../utilities/activity-logger";
import { EarthBrainUtils } from "../../utilities/earthbrainutility";
import { VolumeCalculationUtils } from "../../utilities/volume-calculation-utils";
import { RoadConstructionHandler } from "./road-construction-handler";
import { RoadEditHandler } from "./road-edit-handler";
export class RoadHandler {
    _roadConstructionHandler;
    _roadEditHandler;
    _site;
    _cesiumViewer;
    get editHandler() {
        return this._roadEditHandler;
    }
    constructor(args, cesiumViewer) {
        this._site = args.site;
        this._cesiumViewer = cesiumViewer;
        this._roadConstructionHandler = new RoadConstructionHandler(args, cesiumViewer);
        this._roadEditHandler = new RoadEditHandler(args, cesiumViewer);
    }
    //loaders
    async loadRoadInfo(roadData, stationInterval) {
        const road = await Road.fromJSON(roadData, this._cesiumViewer, stationInterval);
        this._site.addRoad(road);
        ActivityLogger.log(Activity.ROAD_LOADED);
        return road;
    }
    //For JSON data format refer file link: https://cctinc01.sharepoint.com/sites/nCircle-Orizuru/_layouts/15/download.aspx?UniqueId=f87226d610f24c01af5138cc6fe6da15&e=e2oNqQ
    createRoadFromPoints(controlPointArray, associatedTerrain, rubbingDestination) {
        const road = Road.FromControlPoints(controlPointArray, this._cesiumViewer.viewer, getDefaultRoadSettings(), rubbingDestination, associatedTerrain);
        this._site.addRoad(road);
        return road;
    }
    async createRoadFromPointsWithAI(roadPoints, controlPointArray, associatedTerrain, rubbingDestination) {
        const road = await Road.FromControlPointsWithAI(roadPoints, controlPointArray, this._cesiumViewer.viewer, getDefaultRoadSettings(), rubbingDestination, associatedTerrain);
        this._site.addRoad(road);
        return road;
    }
    //construction
    startRoadConstruction(callback, rubbingDestination, associatedTerrain) {
        this._roadConstructionHandler.start(callback, rubbingDestination, associatedTerrain);
    }
    startRoadConstructionWithClickCount(callback, associatedTerrain, rubbingDestination, clickCount, associatePointCloudId, associateDrawing2dImageId) {
        this._roadConstructionHandler.startWithClickCount(callback, rubbingDestination, associatedTerrain, clickCount, associatePointCloudId, associateDrawing2dImageId);
    }
    finishRoadConstruction() {
        this._roadConstructionHandler.finish();
    }
    cancelRoadConstruction() {
        this._roadConstructionHandler.cancel();
    }
    //edit
    startRoadEdit(road, callback) {
        this._roadEditHandler.start(road, callback);
    }
    finishRoadEdit() {
        this._roadEditHandler.end();
    }
    cancelRoadEdit() {
        this._roadEditHandler.cancel();
    }
    //generic updates
    async updateRoadSettings(road, settings = getDefaultRoadSettings()) {
        await road.updatePathSettings(settings);
        this._roadEditHandler.refreshSectionSelection();
        // this._cesiumViewer.viewer.scene.requestRender();
        // this._roadEditCallback && this._roadEditCallback(roadID, false);
    }
    updateRoadMaterial(road, commonMaterial, embarkmentMaterial, cutMaterial) {
        road.updateMaterial(commonMaterial, embarkmentMaterial, cutMaterial);
        // this._cesiumViewer.viewer.scene.requestRender();
    }
    checkRoadUnderCreation() {
        return (this._roadConstructionHandler.road &&
            this._roadConstructionHandler.road.constructionState ===
                ConstructionState.UNDER_CONSTRUCTION);
    }
    getRoadInfo(road) {
        return road.toJSON();
    }
    deleteRoad(roadID) {
        // TODO If the road is getting deleted then remove edits first
        this._site.deleteRoad(roadID);
        // this._cesiumViewer.viewer.scene.requestRender();
    }
    setRoadVisibility(road, show) {
        road.setRoadVisibility(show);
        // this._cesiumViewer.viewer.scene.requestRender();
    }
    fitToRoad(road) {
        road.fitToRoad();
    }
    getLengthOfRoad(road) {
        return road.getLength();
    }
    getRoadSlopeInfo(road) {
        return road.getSlopeInfo();
    }
    getRoadHeightInfo(road) {
        const heightInfo = road.getHeightInfo();
        return heightInfo;
    }
    getRoadHeightInfoOfSection(road, startIndex, endIndex) {
        const heightInfo = road.getHeightInfo();
        return heightInfo;
    }
    //   public get2DViewerDataForPath(id: string): I2DViewData | undefined {
    //     const road = this._site.getRoad(id);
    //     const options = this._cesiumViewer.createIOptions(road.associatePointCloudId);
    //     if (options && options.planeData && options.planeData.associatedRoadId === undefined) {
    //       this._createSectionPlaneForRoad(road, 0, road.isMagnified);
    //     }
    //     return road ? road.get2DViewerData(options) : undefined;
    //   }
    // public getPolylineVolumeGeometry(road: Road): PolylineVolumeGeometry  {
    // return road.getPolylineVolumeGeometry();
    // }
    getMeshGeometry(road) {
        const geometry = road.getGeometry();
        const uniqueGeometry = EarthBrainUtils.removeDuplicateVertices(geometry);
        if (uniqueGeometry.vertices.length > 0) {
            EarthBrainUtils.removeInvalidFacesFromGeometry(uniqueGeometry);
            return {
                vertices: uniqueGeometry.vertices,
                indices: uniqueGeometry.indices,
            };
        }
    }
    getRoadPointLength(road) {
        return road.controlPointLength;
    }
    toggleRoadVisibility(road, show) {
        // if (road.isMagnified) {
        //   road.isMagnified = show;
        // }
        // if (this.roadUnderEditID === roadID) {
        //   this._sectionPlane.show = false;
        // }
        // if (roadID === this._sectionPlaneData.associatedRoadId && this.roadUnderEditID === roadID) this._sectionPlane.show = show;
        road.setRoadVisibility(show);
        // this._viewer.scene.requestRender();
    }
    /**
     * This function will check road in _pathMap and calculate volume of particular Road
     * @param roadID ID of Road whose volume to calculate
     * @returns Fill and Cut Volume calculated based on heightmap
     */
    async volumeCalculationForRoad(road) {
        const data = this.getVolumeCalculationDataForRoad(road);
        if (data.sourceHeightMap === undefined) {
            throw new Error(`Height Map not found for PointCloud ${road.associatedRubbingDestination.id}`);
        }
        //if volume entities in data are above
        return await VolumeCalculationUtils.calculateVolume(data);
    }
    getVolumeCalculationDataForRoad(road) {
        const heightmap = road.associatedTerrain.heightMap;
        return {
            targetHeightMap: road.heightMap.getObject(),
            sourceHeightMap: heightmap.getObject(),
        };
    }
    getRoadLinearData(road, roadInfoObject) {
        return road.getLinearData(roadInfoObject);
    }
}
//# sourceMappingURL=road-handler.js.map